var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (t, timezones, undefined) {
buf.push("<label for=\"preset-email\" aria-describedby=\"preset-email-tip\" class=\"with-input\"><span>" + (jade.escape(null == (jade_interp = t('preset email')) ? "" : jade_interp)) + "</span><input id=\"preset-email\" type=\"email\" name=\"email\" autofocus required><span class=\"indicator\"><span class=\"fa fa-exclamation-triangle\"></span></span></label><p id=\"preset-email-tip\" class=\"tips\">" + (jade.escape(null == (jade_interp = t('preset email tip')) ? "" : jade_interp)) + "</p><label for=\"preset-name\" aria-describedby=\"preset-name-tip\" class=\"with-input\"><span>" + (jade.escape(null == (jade_interp = t('preset name')) ? "" : jade_interp)) + "</span><input id=\"preset-name\" type=\"text\" name=\"public_name\" required></label><p id=\"preset-name-tip\" class=\"tips\">" + (jade.escape(null == (jade_interp = t('preset name tip')) ? "" : jade_interp)) + "</p><label for=\"preset-password\" aria-describedby=\"preset-password-tip\" class=\"with-input\"><span>" + (jade.escape(null == (jade_interp = t('preset password')) ? "" : jade_interp)) + "</span><input id=\"preset-password\" type=\"password\" name=\"password\" required><span class=\"indicator\"><span class=\"fa fa-exclamation-triangle\"></span></span></label><p id=\"preset-email-tip\" class=\"tips\">" + (jade.escape(null == (jade_interp = t('preset password tip')) ? "" : jade_interp)) + "</p><label for=\"preset-timezone\" aria-describedby=\"preset-timezone-tip\" class=\"with-input\"><select id=\"preset-timezone\" name=\"timezone\" required>");
var skipstep  = false
var lastcont = null
// iterate timezones
;(function(){
  var $$obj = timezones;
  if ('number' == typeof $$obj.length) {

    for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
      var timezone = $$obj[index];

if (!( skipstep))
{
var cont = timezone.split('/')[0]
if ( cont != lastcont)
{
lastcont = cont
if ( index)
{
buf.push("<option disabled>" + (jade.escape(null == (jade_interp = '---') ? "" : jade_interp)) + "</option>");
}
}
if ( cont.toLowerCase() == 'africa')
{
skipstep = true
}
}
buf.push("<option" + (jade.attr("value", timezone, true, true)) + ">" + (jade.escape(null == (jade_interp = timezone) ? "" : jade_interp)) + "</option>");
    }

  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;      var timezone = $$obj[index];

if (!( skipstep))
{
var cont = timezone.split('/')[0]
if ( cont != lastcont)
{
lastcont = cont
if ( index)
{
buf.push("<option disabled>" + (jade.escape(null == (jade_interp = '---') ? "" : jade_interp)) + "</option>");
}
}
if ( cont.toLowerCase() == 'africa')
{
skipstep = true
}
}
buf.push("<option" + (jade.attr("value", timezone, true, true)) + ">" + (jade.escape(null == (jade_interp = timezone) ? "" : jade_interp)) + "</option>");
    }

  }
}).call(this);

buf.push("</select><span class=\"indicator\"><span class=\"fa fa-exclamation-triangle\"></span></span></label><p id=\"preset-timezone-tip\" class=\"tips\">" + (jade.escape(null == (jade_interp = t('preset timezone tip')) ? "" : jade_interp)) + "</p><div class=\"checkboxes\"><label for=\"preset-help-us\" class=\"checkbox\"><input id=\"preset-help-us\" type=\"checkbox\" name=\"allow_stats\" checked><span>" + (jade.escape(null == (jade_interp = t('preset opt-in help')) ? "" : jade_interp)) + "</span></label></div><button type=\"submit\" aria-hidden=\"true\"></button>");}.call(this,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined,"timezones" in locals_for_with?locals_for_with.timezones:typeof timezones!=="undefined"?timezones:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/view_register_preset.jade
 ** module id = 77
 ** module chunks = 0
 **/